import request from 'utils/request'
import { MCBHS080InitRequest } from 'types/MCBHS080/MCBHS080InitRequest'
import { MCBHS080OverwriteRequest } from 'types/MCBHS080/MCBHS080OverwriteRequest'
import { MCBHS080NewRequest } from 'types/MCBHS080/MCBHS080NewRequest'

export const initRequest = (apiData: MCBHS080InitRequest) => {
  return request({
    url: '/MCBHS080/init',
    method: 'post',
    data: apiData,
  })
}

// 28KH #181571 START
export const overwriteRequest = (apiData: MCBHS080OverwriteRequest) => {
  return request({
    url: '/MCBHS080/overwrite',
    method: 'post',
    data: apiData,
  })
}

export const newRequest = (apiData: MCBHS080NewRequest) => {
  return request({
    url: '/MCBHS080/saveNew',
    method: 'post',
    data: apiData,
  })
}
// 28KH #181571 END
